import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import config from "../../config/config";
import axios from "axios";
// import DataTable from "react-data-table-component";
// import { Link } from "react-router-dom";
import Loader from "../Loader/Loader";
//MUI Table
import { MaterialReactTable } from "material-react-table";
// import { MenuItem } from "@mui/material";
import { Box, Button, Modal } from "@mui/material";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import { checkUserPermission } from "../../common/UserPermission";

// import { toastSuccess } from "../../../../common/Toast";
// import { DELETE_MESSAGE } from "../../../../common/Constant";

const FilterModal = ({ callback, runApi, closepopup, customerId }) => {
  // const history = useNavigate();
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  // console.log(callback, runApi, "runrun")
  const Location = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const [showModal, setShowModal] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchtext, setSearchText] = useState("");
  const [perPageSize, setperPageSize] = useState();
  const [toggled, setToggled] = useState(false);

  console.log(toggled, "444");
  const onToggle = () => {
    setToggled((t) => !t);
  };
  const [sortingId, setSortingId] = useState(2);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  const [selectCheckbox, setSelectCheckbox] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  console.log(rowSelection, "rowSelection")

  // material model popup
  const [open, setOpen] = useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setGlobalFilter("");
    setData([]);
    setOpen(false);
    closepopup();
  };

  console.log(data, "Filtefedata ==>");
  const handleClick = (row) => {
    setSelectCheckbox(true);
    // setData([])
    console.log(row, toggledClearRows, "65465");
    const selectedIds = row.map((x) => ({ ...x, ReceivingId: 0 }));
    // callback(row.map((el) => el.original));

    const data = row.map((el) => el.original);
    const mapToObjectFormat = (input) => ({
      RowNumber: input?.RowNumber,
      ItemId: input?.ID,
      VariationName: input?.VariationName,
      UnitPrice: input?.Unitprice === null ? 0 : input?.Unitprice,
      CostPrice: input?.Costprice,
      PromoPrice: input?.PromoPrice,
      VariationQuantity: input?.VariationQuantity,
      ItemName: input?.Name,
      Description: input?.Description,
      CategoryName: input?.Categoryfullpath,
      Itemquantity: input?.Quantity,
      VariationId: input?.VariationId,
      AccountName: input?.AccountName,
      ChartOfAccountName: input?.ChartOfAccountName,
      AccountTypeName: input?.AccountTypeName,
      AccountDeatilsTypeName: input?.AccountDeatilsTypeName,
      Module: input?.Module,
      CategoryID: input?.CategoryID,
      ImageName: input?.ImageURL,
      Itemnumber: input?.Itemnumber,
      Allowaltdescription: input?.Allowaltdescription,
      IsItemserialnumber: input?.IsItemserialnumber,
      SupplierID: input?.SupplierID,
      Tier1: input?.Tier1,
      Tier2: input?.Tier2,
      Tier3: input?.Tier3,
      Tier4: input?.Tier4,
      Tier5: input?.Tier5,
      RecallPrice: input?.RecallPrice,
      Lable: input?.Lable,
      SupplierName: input?.Supplier,
      TagName: input?.Tags,
      TotalRecord: input?.TotalRecord,
      ReceivingId: input?.ReceivingId,
      Price: input?.Price === null ? 0 : input?.Price,
      itemquickbookid: Number(input?.QuickbookId),
      isReCallPrice: input?.isReCallPrice,
    });

    const outputArray = data.map(mapToObjectFormat);

    setGlobalFilter("");
    setData([]);
    callback(outputArray);
    setOpen(false);
    closepopup();
  };

  const handleTagIds = (e) => {
    setSelectedTags(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleCategoriesIds = (e) => {
    setSelectedCategories(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleSupplierIds = (e) => {
    setSelectedSupplier(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  let tagsOption = [];
  const Tags = tagData.map((u, i) => {
    tagsOption[i] = { label: u.Name, value: u.ID };
  });
  let categoriesOption = [];
  const Categories = categoriesData.map((u, i) => {
    categoriesOption[i] = { label: u.Name, value: u.ID };
  });
  let supplierOption = [];
  const Suppliers = supplierData.map((u, i) => {
    // supplierOption[i] = { label: u.FirstName, value: u.ID };
    supplierOption[i] = {
      label: u.CompanyName + "(" + u.FirstName + " " + u.LastName + ")",
      value: u.ID,
    };
  });

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    selectedTags,
    selectedCategories,
    responseString,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    console.log(globalFilter,"FilterColumnSearchText");
    setRowSelection({})
    axios
      .get(
        `${
          config.itemsBaseUrl
        }/items/itemselectionlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : encodeURIComponent(globalFilter)
        }&startdate=&enddate=&categoryid=${selectedCategories}&tagid=${selectedTags}&supplierid=${responseString}&LocationID=${Location}&CustomerID=${customerId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const newData = res.data.ResponseData.map((item) => ({
          ...item,
          ReceivingId: 0,
        }));
        setTotalRows(newData[0]?.TotalRecord);
        setData(newData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setCategoriesData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSupplierData(res.data.ResponseData);
        return res;
      });
  }, []);

  const responseString = selectedSupplier?.join(",");

  useEffect(() => {
    if (runApi) {
      setOpen(true);
      handleListData(
        1,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        selectedTags ? selectedTags : "",
        selectedCategories ? selectedCategories : "",
        responseString ? responseString : "",
        columnFilters,
        globalFilter,
        pagination,
        sorting
      );
    }
    // handleListData(1);
  }, [
    // perPageSize,
    // searchtext,
    // sortingId,
    // sortingDirection,
    selectedTags,
    selectedCategories,
    responseString,
    runApi,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    // selectCheckbox
  ]);

  const columns = useMemo(() => [
    {
      header: "ItemId",
      accessorKey: "ID",
      size : 110,
      Cell: ({ row }) =>
        row.original.VariationId > 0
          ? row.original.ID + "#" + row.original.VariationId
          : row.original.ID,
    },
    {
      header: "UPC/EAN/ISBN",
      accessorKey: "Itemnumber",
      size : 110,
    },
    {
      header: "Item Name",
      accessorKey: "Name",
      Cell: ({ row }) => {
        return (
          <div className="word-break-data" title={row.original.Name}>
            {row.original.VariationId != 0
              ? row.original.VariationName
              : row.original.Name}
          </div>
        );
      },
    },
    {
      header: "Category",
      accessorKey: "Categoryfullpath",
      size : 100,
    },
    {
      header: "Cost Price",
      accessorKey: "Costprice",
      size : 100,
      Cell: ({ row }) =>
        parseFloat(
          row.original.Costprice > 0 ? row.original.Costprice : 0
        ).toFixed(2),
        hidden:   toggled == true  ? true : false,
    },
    {
      header: "Unit Price",
      accessorKey: "Unitprice",
      size : 100,
      Cell: ({ row }) =>
        parseFloat(
          row.original.Unitprice > 0 ? row.original.Unitprice : 0
        ).toFixed(2),
    },
    {
      header: "Qty.",
      accessorKey: "Quantity",
      size : 100,
      Cell: ({ row }) =>
        parseFloat(
          row.original.Quantity !== null ? row.original.Quantity : 0
        ).toFixed(2),
    },
    {
      header: "Images",
      accessorKey: "ImageURL",
      size : 100,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.ImageURL != "NO IMAGE" ? (
              <a target="_blank" href={row.original.ImageURL}>
                <img
                  src={
                    row.original.ImageURL
                      ? row.original.ImageURL
                      : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                  }
                  style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
                />
              </a>
            ) : (
              <img
                src={
                  row.original.ImageURL != "NO IMAGE"
                    ? row.original.ImageURL
                    : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                }
                style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
              />
            )}
          </>
        );
      },
    },
    {
      header: "Tag",
      accessorKey: "Tags",
      size : 120,
    },
    {
      header: "Supplier",
      accessorKey: "Supplier",
      Cell: ({ row }) => {
        return (
          <p className="word-break-data" title={row.original.Supplier}>
            {row.original.Supplier != null ? row.original.Supplier : ""}
          </p>
        );
      },
    },
  ]);
  const visibleColumns = columns.filter(columns => columns.hidden !== false);

  const style = {
    height: 600,
    bgcolor: "background.paper",
    border: "2px solid #000",
    // boxShadow: 24,
    p: 1,
  };

  return (
    <>
      <Loader loading={loading} />
      <div>
        {/* <Button onClick={handleOpen}>Open modal</Button> */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="custom-header">
              <p className="title-model" id="exampleModalLabel">
                Filter
              </p>
              <div className="col-md-3">
                <div className="input-group">
                  <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isMulti={true}
                    isClearable={true}
                    onChange={handleTagIds}
                    options={tagsOption}
                    placeholder="Select Tags"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    value={tagsOption.filter((obj) =>
                      selectedTags.includes(obj.value)
                    )}
                    id="TagsIds"
                    name="TagsIds"
                    className="w-100 custom-search-select"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input-group">
                  <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isMulti={true}
                    isClearable={true}
                    onChange={handleCategoriesIds}
                    options={categoriesOption}
                    placeholder="Select Category"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    value={categoriesOption.filter((obj) =>
                      selectedCategories.includes(obj.value)
                    )}
                    id="CategoriesIds"
                    name="CategoriesIds"
                    className="w-100 custom-search-select"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input-group">
                  <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isMulti={true}
                    isClearable={true}
                    onChange={handleSupplierIds}
                    options={supplierOption}
                    placeholder="Select Supplier"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    value={supplierOption.filter((obj) =>
                      selectedSupplier.includes(obj.value)
                    )}
                    id="SupplierIds"
                    name="SupplierIds"
                    className="custom-search-select w-100"
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            {data && (
              <MaterialReactTable
                columns={visibleColumns}
                data={data}
                // tableRef={tableRef}
                enableColumnResizing
                muiTableBodyProps={{
                  sx: () => ({
                    "& tr:nth-of-type(even)": {
                      backgroundColor: "var(--datatable-row-background-color)",
                      //'rgb(237 237 233 / 63%)'
                    },
                    "& td": {
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    },

                    "& tr": {
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    },
                  }),
                }}
                enableGrouping
                // enableStickyHeader
                // enableStickyFooter
                enableRowSelection
                enableColumnOrdering

                // autoResetAll = {selectCheckbox}
                initialState={{
                  density: "compact",

                  pagination: { pageIndex: 0, pageSize: 10 },
                  // sorting: [{ id: "state", desc: false }], //sort by state by default
                }}
                // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                muiTableContainerProps={{ sx: { maxHeight: 420 } }}
                // muiPaginationProps={{
                //   rowsPerPageOptions: [10, 25, 50, 100, 300],
                // }}
                muiPaginationProps={{
                  rowsPerPageOptions: [10, 25, 50, 100, 300],
                }}
                muiTableBodyCellProps={{
                  sx: { borderLeft: "1px solid #E0E0E0" },
                }}
                muiTableHeadCellProps={{
                  sx: (theme) => ({
                    background: "var(--datatable-row-background-color)", //'#e9e9e9',
                    borderRight:
                      "1px solid var(--datatable-row-background-hover-color)",
                    lineHeight: "16px",
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "var(--primary-color-800)",
                    fontFamily: "Inter",
                  }),
                }}
                manualFiltering
                manualPagination
                manualSorting
                onColumnFiltersChange={setColumnFilters}
                onGlobalFilterChange={setGlobalFilter}
                onPaginationChange={setPagination}
                onSortingChange={setSorting}
                onRowSelectionChange={setRowSelection}
                rowCount={totalRows}
                state={{
                  columnFilters,
                  globalFilter,
                  isLoading,
                  pagination,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                  sorting,
                  rowSelection
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      size="small"
                      // className="btn btn-sm btn-primary btn-sm pull-right"
                      style={{color: "white" , backgroundColor : "#111931" , padding: "10px" , fontSize: "14px"}}
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleClick(table.getSelectedRowModel().rows)
                      }
                      // startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Add
                    </Button>
                    <div className="d-flex flex-row mt-3">
                                  {/* <div className="col-md-12 "> */}
                                  <div className="form-check form-switch mb-3 pull-right">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="toggle-button"
                                      checked={toggled}
                                      onChange={onToggle
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="toggle-button"
                                    >
                                      {toggled
                                        ?  "Show Cost Price" : " Hide Cost Price"}
                                    </label>
                                  </div>
                                  {/* </div> */}
                                </div>
                  </Box>
                )}
              />
            )}
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default FilterModal;
